// 启动费
import { i18n, sprintf } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let contractInfo = get(state, 'currentShopBaseDetail', {})
  return {
    title: i18n.gettext('启动费'),
    content: [
      {
        title: i18n.gettext('金额(MX$)'),
        label: contractInfo.startupCost / 100
      },
      {
        title: i18n.gettext('开始扣费时间'),
        label: sprintf(i18n.gettext('签约%d周后'), contractInfo.startupExecWeek)
      },
      {
        title: i18n.gettext('扣费比例'),
        label: `${contractInfo.startupCostProportion / 100}%`
      },
      {
        title: i18n.gettext('单次最大扣费金额(MX$)'),
        label: contractInfo.startupCostLimit / 100
      }
    ]
  }
}
